import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import DeleteIcon from '@mui/icons-material/Delete';
import PeopleIcon from '@mui/icons-material/People';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { School } from 'components/models/FormProps';
import DeleteAudienceDialog from './DeleteAudienceDialog';
import OutOfScopeFlag, { OUT_OF_SCOPE_ROW_SX } from './OutOfScopeFlag';

interface Props {
  removeViewableEntitiesCallback: (viewableEntities: Array<School>) => void;
  viewOnly: boolean;
  tableHeader: string;
  pluralEntityName: string;
  school: School;
  // Only the student audience has a scope constraint to violate; the staff
  // audience the table also serves leaves this alone and flags nothing.
  outOfScope?: boolean;
}

export default function SchoolTable(props: Props): React.ReactElement {
  const { tableHeader, pluralEntityName, school, removeViewableEntitiesCallback, viewOnly, outOfScope = false } = props;

  return (
    <TableContainer component={Paper} style={{ flex: 1, overflow: 'visible' }}>
      <Table size="small" aria-label="Selected school">
        <TableBody>
          <TableRow sx={outOfScope ? OUT_OF_SCOPE_ROW_SX : undefined}>
            <TableCell>
              <Stack direction="row" spacing={1} alignItems="center">
                <PeopleIcon color="action" />
                <Typography variant="body2">{tableHeader}</Typography>
              </Stack>
              {outOfScope && <OutOfScopeFlag />}
            </TableCell>
            <TableCell align="right">
              <DeleteAudienceDialog
                icon={<DeleteIcon fontSize="small" color={outOfScope ? 'warning' : undefined} />}
                viewOnly={viewOnly}
                removeAudienceCallback={() => removeViewableEntitiesCallback([school])}
              >
                <DialogTitle>{`Remove all ${pluralEntityName}?`}</DialogTitle>
                <DialogContent>
                  <Typography>
                    {`This will deselect all ${pluralEntityName} in ${school.name}`}
                  </Typography>
                </DialogContent>
              </DeleteAudienceDialog>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
